var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "sc-wrapper"
  }, [_c('div', {
    staticClass: "flying",
    style: {
      backgroundImage: 'url(' + _vm.capKeybd + '), none'
    }
  }), _c('div', {
    staticClass: "arrow",
    style: {
      backgroundImage: 'url(' + _vm.arrow + '), none'
    }
  }), _c('div', {
    staticClass: "arrowDraw",
    style: {
      backgroundImage: 'url(' + _vm.arrowDraw + '), none'
    }
  }), _c('div', {
    staticClass: "bullseye",
    style: {
      backgroundImage: 'url(' + _vm.bullseye + '), none'
    }
  }), _c('div', {
    staticClass: "cloud",
    style: {
      backgroundImage: 'url(' + _vm.bgCloud + '), none'
    }
  }), _c('div', {
    staticClass: "cloud cloud1",
    style: {
      backgroundImage: 'url(' + _vm.bgCloud + '), none'
    }
  }), _c('div', {
    staticClass: "cloud cloud2",
    style: {
      backgroundImage: 'url(' + _vm.bgCloud + '), none'
    }
  }), _c('div', {
    staticClass: "grass",
    style: {
      backgroundImage: 'url(' + _vm.bgGrass + '), none'
    }
  }), !_vm.playingAnimation ? _c('intro-button', {
    staticClass: "intro-button",
    attrs: {
      "is-loading": _vm.isLoading,
      "on-click": _vm.playAnimation,
      "transition": "fade"
    }
  }) : _vm._e(), !_vm.playingAnimation ? _c('h1', {
    staticClass: "activity-title",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n    Spot Check\n  ")]) : _vm._e(), !_vm.playingAnimation ? _c('h2', {
    staticClass: "activity-subtitle",
    attrs: {
      "transition": "fade"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.activityTitle.display) + "\n  ")]) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }